<template>
  <div class="lead-notes d-flex h-100 flex-column flex-wrap rounded-bottom">
    <div class="lead-notes">
      <div class="placeholder form-control border-bottom border-left-0 border-right-0 border-top-0 rounded-0 py-2" @click="displayAddNote">
        <font-awesome-icon icon="edit" /> <span class="ml-2">{{ $t('Click to add a note') }}</span>
      </div>
      <b-form v-if="addNoteVisible" class="lead-notes__form position-relative py-2" @submit.prevent="addNote">
        <b-input v-model="newNote" placeholder="Type your note..." class="lead-notes__form__input font-italic border-0" />
        <b-spinner v-if="busy" class="lead-notes__form__button" />
        <b-button v-else size="sm" variant="outline-secondary" class="lead-notes__form__button px-3" @click="addNote">
          {{ $t('Save') }}
        </b-button>
      </b-form>
    </div>
    <div v-if="notes.length > 0" class="lead-notes__container">
      <ul class="lead-notes__container__list lead-notes__container__list--scrollable list-unstyled">
        <li v-for="(note, key) in notes" :key="key" class="lead-notes__container__list__note d-flex font-size-14">
          <div class="single-note float-left">
            <span class="lead-notes__container__list__note__heading text-muted">
              {{ $d(parseJsonDate(note.created), 'shortWithTime') }}
            </span>
            <span class="lead-notes__container__list__note__body d-block">
              {{ note.text }}
            </span>
          </div>
          <b-button size="sm" variant="empty" class="single-note-removal text-center float-left" @click="removeNote(note.id, key)">
            <font-awesome-icon icon="times" />
          </b-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import dates from '@/services/date';
import notification from "@/imports/mixins/notification";

export default {
  name: "LeadNotes",
  mixins: [notification],
  props: {
    notes: {
      type: Array,
      default: () => [],
    },
    busy: Boolean,
    leadCode: {
      type: String,
      default: null,
    },
  },
  data: function() {
    return {
      newNote: this.value,
      addNoteVisible: false,
    }
  },
  methods: {
    parseJsonDate: dates.parseJsonDate,
    displayAddNote: function() {
      this.addNoteVisible = true;
    },
    addNote: function() {
      if (this.newNote !== null && this.newNote !== '' && this.newNote !== undefined) {
        this.$emit('input', this.newNote);
        this.newNote = null;
        this.addNoteVisible = false;
      }
    },
    removeNote: function(noteId, index) {
      this.noteBusy = true;
      this.$api.leads.removeNote(noteId, this.leadCode).then(() => {
        this.noteBusy = false;
        this.notes.splice(index, 1);
      }).catch(() => {
        this.notify(this.$bvToast, 'There was an error removing your note', null, 'danger');
        this.noteBusy = false;
      });
    },
    parseDateTime: function(datetime) {
      let date = new Date(datetime);
      return date.toLocaleString(['en-GB']);
    },
  },
}
</script>

<style scoped lang="scss">
.lead-notes {
  width: 100%;
  position: relative;

  &__container {
    @include media-breakpoint-up(md) {
      height: 100%;
    }

    width: 100%;
    background-color: $white;
    padding: 20px 5px 20px 20px;

    &__list {
      height: 100%;
      padding: 0;
      margin: 0;
      overflow-y: hidden;

      &--scrollable {
        overflow-y: auto;
        max-height: 314px;
      }

      &__note {
        padding-bottom: 10px;

        &__heading {
          font-weight: 600;
          font-size: $font-size-13;
        }

        &__body {
          font-size: $font-size-14;
        }
      }
    }
  }

  &__form {
    background-color: $body-bg;
    border-top: 1px solid $border-color;

    &__input {
      outline: none;
      background: transparent;

      &:focus {
        background: transparent;
        outline: none;
        box-shadow: none !important;
      }
    }

    &__button {
      position: absolute;
      right: 10px;
      top: 11px;
    }
  }

  .placeholder {
    cursor: pointer;
    height: 46px;
    display: flex;
    align-items: center;

    span {
      font-size: 12px;
    }
  }
}

.single-note {
  width: calc(100% - 40px);
  &-removal {
    width: 40px;
    height: 30px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &:before {
      content: '\200C';
      height: 100%;
      width: 1px;
      background: $border-color;
      position: absolute;
      left: 0;
    }
  }
}
</style>
